/**
 * Categorias suportadas no portal de anexos de cotações
 * (POST `/purchase-order-quotations/{id}/documents`, campo `category`).
 *
 * Mantida como lista fixa para padronizar filtros/relatórios futuros.
 * Se a categoria desejada não estiver aqui, escolha `Outros` e detalhe
 * em `description`.
 */
export enum QuotationDocumentCategory {
  ORCAMENTO = 'Orcamento',
  CONTRATO = 'Contrato',
  PROPOSTA = 'Proposta',
  ESPECIFICACAO_TECNICA = 'Especificação Técnica',
  NOTA_FISCAL = 'Nota Fiscal',
  OUTROS = 'Outros'
}

export interface QuotationDocumentCategoryOption {
  value: QuotationDocumentCategory;
  label: string;
  description?: string;
}

/** Lista exibida em `<select>` no formulário de upload. */
export const QUOTATION_DOCUMENT_CATEGORY_OPTIONS: readonly QuotationDocumentCategoryOption[] = [
  { value: QuotationDocumentCategory.ORCAMENTO, label: 'Orçamento' },
  { value: QuotationDocumentCategory.PROPOSTA, label: 'Proposta' },
  { value: QuotationDocumentCategory.CONTRATO, label: 'Contrato' },
  {
    value: QuotationDocumentCategory.ESPECIFICACAO_TECNICA,
    label: 'Especificação técnica'
  },
  { value: QuotationDocumentCategory.NOTA_FISCAL, label: 'Nota fiscal' },
  { value: QuotationDocumentCategory.OUTROS, label: 'Outros' }
] as const;
